/** Hamburger drawer toggle for the brand nav (mobile-only).
 *  CSS handles the visual slide via a `.drawer-open` body class; this script
 *  handles state, aria attributes, and dismissing on link tap. */

export function initBrandMenu(): void {
  const toggle = document.getElementById('brand-menu-toggle');
  const panel = document.getElementById('brand-menu-drawer-panel');
  if (!toggle || !panel) return;

  const set = (open: boolean): void => {
    toggle.setAttribute('aria-expanded', String(open));
    panel.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('drawer-open', open);
  };

  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    const next = toggle.getAttribute('aria-expanded') !== 'true';
    set(next);
  });

  // Tapping a link inside the drawer closes it. Navigation will close it anyway
  // by leaving the page, but this keeps the visual state correct if the click
  // is intercepted (e.g. cmd-click into a new tab).
  panel.addEventListener('click', (e) => {
    if ((e.target as HTMLElement).closest('a')) set(false);
  });
}
